
export default "/assets/code-bracket-micro.0197277a.svg"